import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { 
    Alert, 
    CircularProgress,
    TextField, 
    Button, 
    Box, 
    Typography,
    Paper,
    InputAdornment
} from '@mui/material';
import { 
    PersonOutline as PersonIcon,
    Lock as LockIcon
} from '@mui/icons-material';
import './Login.css';
import logo from './secundarios/recursos/logo.png';

function Login() {
    const apiUrl = process.env.REACT_APP_API_URL;
    const [formData, setFormData] = useState({
        id_login_empleado: '',
        contraseña: ''
    });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const response = await fetch(`${apiUrl}/api/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            const data = await response.json();

            if (response.ok) {
                localStorage.setItem('token', data.token);
                localStorage.setItem('auth', 'true');
                const redirectTo = location.state?.from?.pathname || '/inicio';
                navigate(redirectTo, { replace: true });
            } else {
                setError(data.message || 'Credenciales incorrectas');
            }
        } catch (err) {
            setError('Error de conexión con el servidor');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box className="login-container">
            <Box className="login-left-side">
                {/* Parte izquierda con el gradiente */}
            </Box>
            
            <Box className="login-right-side">
                <Paper elevation={0} className="login-card">
                    <Box className="login-header">
                        <div className="login-title">
                            FLASH  <span  id='login-title1'>ESTILISTAS</span>
                        </div>
                        <div className="login-subtitle">
                            Sistema de gestión de citas
                        </div>
                    </Box>

                    {error && (
                        <Alert severity="error" sx={{ mb: 3, width: '100%' }}>
                            {error}
                        </Alert>
                    )}

                    <form onSubmit={handleSubmit} className="login-form">
                    <TextField
    label="Usuario"
    variant="outlined"
    name="id_login_empleado"
    value={formData.id_login_empleado}
    onChange={handleChange}
    required
    fullWidth
    margin="normal"
    InputProps={{
        startAdornment: (
            <InputAdornment position="start">
                <PersonIcon />
            </InputAdornment>
        ),
        classes: {
            root: 'custom-input-root',
            focused: 'custom-input-focused',
        }
    }}
    InputLabelProps={{
        classes: {
            root: 'custom-label',
            focused: 'custom-label-focused',
        }
    }}
    placeholder="Ingrese su usuario"
    className="login-input"
/>

                        <TextField
                            label="Contraseña"
                            variant="outlined"
                            type="password"
                            name="contraseña"
                            value={formData.contraseña}
                            onChange={handleChange}
                            required
                            fullWidth
                            margin="normal"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <LockIcon />
                                    </InputAdornment>
                                ),
                            }}
                            placeholder="Ingrese su contraseña"
                            className="login-input"
                        />

                        <Button
                            type="submit"
                            variant="contained"
                            className="login-button"
                            disabled={loading || !formData.id_login_empleado}
                            fullWidth
                            size="large"
                        >
                            {loading ? (
                                <CircularProgress size={24} color="inherit" />
                            ) : (
                                'ENTRAR'
                            )}
                        </Button>
                    </form>

                    <Box className="login-footer">
                        <Typography variant="body2" color="textSecondary">
                            © {new Date().getFullYear()} FlashEstilistas - by Michelo
                        </Typography>
                    </Box>
                </Paper>
            </Box>
        </Box>
    );
}

export default Login;